module.exports = __webpack_public_path__ + "media/images/arr_w-0977128f45046df2717ffbc0d6bc43a5.svg";